/**
 * ISO 문자열을 KST "HH:mm" 형태로 변환
 */
export function formatTime(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleTimeString('ko-KR', {
    timeZone: 'Asia/Seoul',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/**
 * ISO 문자열을 "YYYY-MM-DD" 형태로 변환
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  const year = date.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', year: 'numeric' }).replace(/[^0-9]/g, '');
  const month = date.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', month: '2-digit' }).replace(/[^0-9]/g, '');
  const day = date.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', day: '2-digit' }).replace(/[^0-9]/g, '');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

/**
 * 오늘 날짜를 KST "YYYY-MM-DD" 형태로 반환
 */
export function getKSTTodayString(): string {
  return formatDate(new Date().toISOString());
}
